import { Box, Divider, Flex, Grid, IconButton, Image, Text, Drawer, DrawerBody, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton, FormControl, FormLabel, Input, Button, FormErrorMessage, useDisclosure, Select, } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import ReferenceDetailLogo from '../../../../../assets/images/ReferenceDetailLogo.svg';
import EditLogo from "../../../../../assets/images/EditLogo.svg";
import { EmployeePersonalInfo } from "./modal";
import { Controller, useForm } from "react-hook-form";
import { useFetch } from "../../../../../hooks/useFetch";
import { CustomToast } from "../../../../../components";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ReferenceDetail } from "./modal";
import { useAuth } from "../../../../../hooks/useAuth";

interface Props {
    employeeId: number | null;
    personalDetail?: EmployeePersonalInfo;
    reload: () => void;
}

export interface IReference {
    empId?: number | null;
    reference_id: number;
    referred_By: string;
};

const ReferenceDetails = ({ employeeId, personalDetail, reload }: Props) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);
    const { hasPermission } = useAuth();
    const [referenceDropdown, setReferenceDropdown] = useState<any>([])

    const ReferenceSchema: any = yup.object().shape({
        reference_id: yup.number().required("Reference is required").typeError("Reference is required"),
        referred_By: yup.string().nullable().matches(/^[A-Za-z\s]+$/, "Referred By can only contain letters and spaces").when("reference_id", {
            is: (val: number) => val !== 1,
            then: (schema) => schema.required("Referred By is required"),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),
    })

    const { control, handleSubmit, formState: { errors, isSubmitting }, reset, watch } = useForm<IReference>({
        resolver: yupResolver(ReferenceSchema),
        defaultValues: {
            reference_id: personalDetail?.reference_id || 0,
            referred_By: personalDetail?.referred_By || "",
        },
    });

    const selectedReferenceId = watch("reference_id");

    function handleEditClick() {
        reset({
            reference_id: personalDetail?.reference_id,
            referred_By: personalDetail?.referred_By,
        });
        onOpen();
    }

    const onSubmit = async (data: IReference) => {
        data.empId = employeeId;

        // Ensure referred_By is empty if reference_id === 1
        if (Number(data.reference_id) === 1) {
            data.referred_By = "";
        }

        let endpoint = `Hrlense_Employee/personalDetail/${employeeId}`;
        const response = await fetchApi(endpoint, "PUT", data, null, "Reference Details Updated");
        if (response) {
            reload();
            onClose();
        }
    };


    const ReferenceDropDown = async () => {
        const response = await fetchApi("DropDown/reference", "GET", null, "");
        if (response) {
            setReferenceDropdown(response);
        }
    };

    useEffect(() => {
        ReferenceDropDown();
    }, [employeeId]);

    return (
        <>

            <Box pt={2} mb={6} className="main">
                <Flex justify="space-between" align="center" mb={2} pl={5} pr={5}>
                    <Flex align="center" gap={3}>
                        <Image src={ReferenceDetailLogo} alt={"Benifits & ID Numberss"} />
                        <Text className="font-poppins text_sm text_medium col">
                            Reference Details
                        </Text>
                    </Flex>
                    {hasPermission('Employee', 'UpdateReferenceDetail') && (<IconButton aria-label="Edit" icon={<Image src={EditLogo} />} variant="none" onClick={() => handleEditClick()} />)}
                </Flex>

                <Box py={2} px={10} bg="#FFFFFF" borderRadius={8}>
                    {ReferenceDetail.map((data, index) => {
                        if (data.key === "referred_By" && personalDetail?.reference_id === 1) {
                            return null;
                        }
                        return (
                            <Grid key={index} templateColumns="1fr 1fr" alignItems="center" py={2}>
                                <Text className="font-poppins text_sm text_medium" color="rgba(102, 102, 102, 1)" >
                                    {data?.label}
                                </Text>
                                <Text className="font-poppins text_sm text_medium col">
                                    {personalDetail?.[data?.key]}
                                </Text>
                            </Grid>
                        );
                    })}
                </Box>

            </Box>


            {/* Drawer for editing */}
            <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="md">
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader>Update Reference Details</DrawerHeader>
                    <DrawerBody>
                        <form onSubmit={handleSubmit(onSubmit)}>

                            <FormControl isInvalid={!!errors.reference_id} isRequired mb={4}>
                                <FormLabel>Reference</FormLabel>
                                <Controller
                                    name="reference_id" control={control}
                                    render={({ field }) => (
                                        <Select {...field} placeholder="Select Reference">
                                            {referenceDropdown.map((opt: any) => (
                                                <option key={opt.id} value={opt.id}>
                                                    {opt.reference}
                                                </option>
                                            ))}
                                        </Select>
                                    )}
                                />
                                <FormErrorMessage> {errors.reference_id?.message} </FormErrorMessage>
                            </FormControl>

                            {Number(selectedReferenceId) !== 1 && (
                                <FormControl isInvalid={!!errors.referred_By} isRequired mb={4}>
                                    <FormLabel> Referred By </FormLabel>
                                    <Controller
                                        name="referred_By" control={control}
                                        render={({ field }) => (
                                            <Input type="string"  {...field} />
                                        )}
                                    />
                                    <FormErrorMessage>{errors.referred_By?.message}</FormErrorMessage>
                                </FormControl>
                            )}

                            <Box mt={6} textAlign="right">
                                <Button type="submit" className="btn_theme btn_theme:hover" isLoading={isSubmitting}>
                                    Update
                                </Button>
                            </Box>
                        </form>

                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </>

    );
};

export default ReferenceDetails;
